<div class="service-ending py-3" *ngIf="showNotice">
  <div class="container d-md-flex align-items-center justify-content-center">
    <div class="col-12 mx-2">
      <p class="text-white fw-bold my-auto text-center">
        {{ "service:ending:notice" | translate }}
      </p>
    </div>
  </div>
</div>
